import styled from 'styled-components'

import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Description = styled.div`
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.regular}
    padding: 0 0 50px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL}
        padding-bottom: 100px;
    }
`

export const ServicesItem = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 360px;
    transition: 0.3s ease-in-out;
    z-index: 1;
`

export const ServicesItemWrapper = styled.div`
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    height: 450px;

    &:after {
        content: ' ';
        width: 100%;
        height: 100%;
        position: absolute;
        background: none;
        transition: 0.3s ease-in-out;
        top: 0px;
    }

    &:hover {
        &:after {
            background: rgba(0, 0, 0, 0.7);
        }

        ${ServicesItem} {
            margin-top: 0px;
        }
    }
`

export const Title = styled.h3`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.bold}
`

export const ItemDescription = styled.div`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.regular}
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.white};
    margin-top: 10px;
    display: block;
    text-transform: uppercase;
    text-decoration: none;

    svg {
        margin-left: 5px;
    }

    &:hover {
        color: ${(props) => props.theme.color.a500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    padding: 50px 20px;
    background-color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'p600' : 'white']};

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 150px 0;
    }

    ${Description} {
        color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'white' : 'p600']};
    }
`
